import React from 'react';
import { getOrdersSearchProperties, getSelectedOrderSearchAction } from '../../../../../../../selectors/tools';
import { useSelector } from 'react-redux';
import SearchHeaderText from '../SearchHeaderText/SearchHeaderText';

const SearchHeaderResultsText = () => {
  const ordersSearch = useSelector(getOrdersSearchProperties);
  const selectedSearchAction = useSelector(getSelectedOrderSearchAction);
  const resCnt = ordersSearch.orders.length;

  if (!resCnt) {
    return null;
  }

  const label = selectedSearchAction.includes('Email') ? 'email' : 'order number';
  const text = `There ${resCnt > 1 ? 'are' : 'is'} ${resCnt} order  ${
    resCnt > 1 ? 's' : ''
  } associated with this ${label}`;

  return <SearchHeaderText text={text} />;
};

export default SearchHeaderResultsText;
